import { z } from "zod";
export const transactionStatusSchema = z.enum([
    "PENDING",
    "ACCEPTED",
    "WAITING_FOR_PAYOUT",
    "SENT_TO_FINAGO",
    "PAID",
    "CANCELLED",
]);
export const transactionActionSchema = z.object({
    action: z.enum(["accept", "mark-paid", "cancel"]),
});
export const transactionActionResponseSchema = z.object({
    status: transactionStatusSchema,
});
export const updateFinagoReferenceSchema = z.object({
    finagoReference: z.string().trim().min(1).max(80),
});
export const updateFinagoReferenceResponseSchema = z.object({
    finagoReference: z.string(),
});
